module.exports = __webpack_public_path__ + "static/media/charger-pin-public.55f5f665.png";